import { render, staticRenderFns } from "./seafarer_view.vue?vue&type=template&id=8a0c2c70&scoped=true&"
import script from "./seafarer_view.vue?vue&type=script&lang=js&"
export * from "./seafarer_view.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./seafarer_view.vue?vue&type=style&index=1&id=8a0c2c70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0c2c70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oem/work/Rails/tosdere_erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('8a0c2c70', component.options)
    } else {
      api.reload('8a0c2c70', component.options)
    }
    module.hot.accept("./seafarer_view.vue?vue&type=template&id=8a0c2c70&scoped=true&", function () {
      api.rerender('8a0c2c70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/admin/seafarer_reg/seafarer_view.vue"
export default component.exports